import InfoModalContainerConstants from './constants';

export const openInfoModal = ({
  langKey,
  langKeyHeader,
  closeButtonLangKey,
  onAfterClose,
}: {
  langKey: string;
  langKeyHeader: string;
  closeButtonLangKey: string;
  onAfterClose?: () => void;
}) => ({
  langKey,
  langKeyHeader,
  closeButtonLangKey,
  onAfterClose,
  type: InfoModalContainerConstants.OPEN_INFO_MODAL,
});

export const closeInfoModal = () => ({
  type: InfoModalContainerConstants.CLOSE_INFO_MODAL,
});
